import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/funding_sources/authorize_iframe/{district_id}
export const syncFundingSources = async () => {
  const response = await new Request().get('/ajax/funding_sources/sync/')
  return Util.Obj.keysToCamel(response.data)
}
